<template>
  <v-btn class="normal-btn-text elevation-0 rounded-tag-small ml-2"
         :loading="loadingPdf"
         @click="gerarPdf">
    <v-icon>mdi-file-pdf-box</v-icon>
    Gerar PDF
  </v-btn>
</template>

<script>
import VendasService from '../vendas-service';

export default {
  props: {
    venda: Object,
  },
  data() {
    return {
      loadingPdf: false,
    };
  },
  methods: {
    gerarPdf() {
      this.loadingPdf = true;
      return VendasService.generatePdf(this.venda.id)
        .then(({ data }) => {
          const blob = new Blob([data], { type: 'application/pdf' });
          const objectUrl = URL.createObjectURL(blob);
          window.open(objectUrl);
        })
        .finally(() => {
          this.loadingPdf = false;
        });
    },
  },
};
</script>
